import { useState } from "react";

const faqs = [
  {
    q: "爆料专区的信息来源可靠吗？",
    a: "我们坚持多信源交叉验证原则，每条爆料至少经过三方独立信源核实后才会发布。对于无法完全验证的内容，我们会明确标注「待核实」标签，让读者自行判断。",
  },
  {
    q: "如何匿名投稿？会被追踪到身份吗？",
    a: "爆料专区采用端到端加密投稿系统，投稿人的 IP 地址、设备信息等一切可追踪数据均不会被记录或存储。你只需发送邮件至投稿邮箱，系统自动剥离所有元数据后再转发给编辑团队。",
  },
  {
    q: "内容涉及法律风险怎么办？",
    a: "我们的法务团队会对每条爆料进行合规审查，确保内容在法律框架内发布。对于涉及诉讼风险的敏感内容，我们会采用化名、模糊处理等方式保护各方权益，同时保留核心事实。",
  },
  {
    q: "为什么有些爆料后来删除了？",
    a: "两种情况：一是当事人通过合法途径申诉且提供有效证据证明内容不实，我们会立即下架并公开更正；二是涉及隐私保护或法院禁制令，我们依法配合删除。每次删除都会发布简短说明。",
  },
  {
    q: "如何区分真实爆料和恶意造谣？",
    a: "我们有严格的审核流程：所有爆料需附带至少一项可验证证据（截图、录音、文件等），纯文字无证据的爆料一律不发布。同时我们会联系被爆料方给予回应机会，呈现双方说法。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          常见疑问
        </h2>
        <div className="w-16 h-1 bg-accent-500 mx-auto mb-10 rounded-full"></div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
              >
                <h3 className="font-heading text-foreground-200 text-sm pr-4">{faq.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg flex-shrink-0 transition-transform duration-200 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-foreground-400 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}